import { TutorialImage } from "./tutorial-image";
import { TutorialMediaPlaceholder } from "./tutorial-media-placeholder";
import { YouTubePlayer } from "../scanner/youtube-player";

export const mediaComponent = (item) => {
  if (!item.url) {
    return <TutorialMediaPlaceholder />;
  }
  switch (item.type) {
    case "img":
      return <TutorialImage info={item} />;
    case "vid":
      return <YouTubePlayer url={item.url} mute={false} />;
    default:
      return <TutorialMediaPlaceholder />;
  }
};
